export const NavData = [
  {
    id: "About",
    name: "About",
    leftLineFlex: 0,
    rightLineFlex: 1,
    offest: 200,
    src: process.env.PUBLIC_URL + "/images/about.jpeg",
  },
  {
    id: "Work",
    name: "Work",
    leftLineFlex: 3,
    rightLineFlex: 1,
    offest: -500,
    src: process.env.PUBLIC_URL + "/images/about.jpeg",
  },
  {
    id: "Contact",
    name: "Contact",
    leftLineFlex: 1,
    rightLineFlex: 3,
    offest: 300,
    src: process.env.PUBLIC_URL + "/images/about.jpeg",
  },
];
